import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import { useEffect, useState } from "react";
import InputComponent from "../evaluation-form-components/input";
import { validatePassword } from "../../utils/default";

const Container = styled.div`
    width: calc(480px - 72px);
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .label-modal {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 24px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;
        display: flex;
        gap: 24px;

        .button-box {
            width: 50%;
        }
    }
`;

function ResetPasswordModal({
    open,
    title,
    labelConfirm,
    labelBack,
    onBack,
    onConfirm,
}) {
    const [inputValue, setInputValue] = useState("");
    const [isError, setIsError] = useState(false);
    const [labelError, setLabelError] = useState("");

    useEffect(() => {
        if (!open) {
            setInputValue("");
        }
    }, [open])

    function handleInput(param) {
        setInputValue(param)
        setIsError(false)
        setLabelError("")
    }
    function handleBack() {
        onBack && onBack();
    }
    function handleConfirm() {
        if (!validatePassword(inputValue)) {
            setIsError(true)
            setLabelError("รหัสผ่านต้อง 8 ตัวอักษรขึ้นไป และมีทั้งตัวอักษร กับตัวเลข")
            return;
        }
        onConfirm && onConfirm(inputValue);
    }

    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container>
                <div className="label-modal content-center">{title || ""}</div>
                <InputComponent
                    label={"รหัสผ่านใหม่"}
                    placeholder={"กรุณากรอกรหัสผ่านใหม่"}
                    styleInput={{ border: "1px solid #B5B5B5" }}
                    type={"password"}
                    value={inputValue}
                    isError={isError}
                    labelError={labelError}
                    onInput={handleInput}
                />
                <div className="button-container">
                    <div className="button-box">
                        <ButtonComponent
                            label={labelBack || ""}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleBack}
                        />
                    </div>

                    <div className="button-box">
                        <ButtonComponent
                            label={labelConfirm || ""}
                            variant={"primary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            disable={inputValue ? false : true}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default ResetPasswordModal;